import { Component, OnInit } from '@angular/core';
import { LcvApiService } from '../services/lcv-api.service';
import { LcvDataMapperService } from '../services/lcv-data-mapper.service';
import { LcvFormatterService } from '../services/lcv-formatter.service';
import { LcvLogicHelperService } from '../services/lcv-logic-helper.service';
import { BarChartOptions, ChartHelperService, ColumnChartOptions, PieChartOptions } from '../services/chart-helper.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';
import { Store } from '@ngrx/store';
import { selectSelectedOrganization } from 'src/app/state/selectors/selectedOrganization.selectors';

@Component({
  selector: 'app-libro-compra-venta',
  templateUrl: './libro-compra-venta.component.html',
  styleUrls: ['./libro-compra-venta.component.scss']
})
export class LibroCompraVentaComponent implements OnInit {
  
  public validatingCredentials: boolean = true;
  public showReload: boolean  = false;
  public loadingMessage: string = "Validando credenciales"

  public periodoActual: number = 2024; //Que tome currentyear

  public periodos: number[] = [];

  // Crear reporte
  public errores: any[] = [];
  public anyCompleted: boolean = false;

  public userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
  private _userInfo$: Observable<IUserInfoCognito> = this.store.select(selectUserInfo);

  public selectedOrganization: string = this._sessionService.getOrganization();;
  private _selectedOrganization$ = this.store.select(selectSelectedOrganization);

  constructor(
    private _apiService: LcvApiService,
    private _sessionService: SessionService,
    private _logicHelper: LcvLogicHelperService,
    private toastr: ToastrService,
    private router: Router,
    private store: Store
    ) { }

  ngOnInit(): void {
    this._userInfo$.subscribe((userInfo) => {
      this.userInfo = userInfo;
    })
    this.makeStartUpApiCalls();
  }

  private makeStartUpApiCalls() {
        if(!this.userInfo) return;
        let currentRut = this.selectedOrganization;
        let currentUser = this.userInfo.username;
        this._apiService.validateCredentials(currentUser, currentRut).subscribe(
          (data: any) => {
            if(this._logicHelper.validaCredencialReturn(data?.services)){
              const today = new Date();
              this.periodoActual = today.getFullYear();
              const userInfo = this.userInfo!;
              this.crearReporte(userInfo, currentRut);
              // this.getGraphData(token);
            } else {
              this.toastr.error('', 'No se han encontrado las credenciales del rut sincronizadas.');      
              this.router.navigate(['/actualizar-credenciales'])      
              this.validatingCredentials = false;
            }
          },
          ({ error }) => {
            this.router.navigate(['/actualizar-credenciales']);
            this.toastr.error('', error.message || 'Ha ocurrido un error al obtener las credenciales del rut.');
            this.showReload = true;
          })
  }

  crearReporte(userInfo: IUserInfoCognito, rut: string) {
    this.loadingMessage = "Creando reportes";

    this.errores = [];
    this.anyCompleted = false;
    this.periodos = [(this.periodoActual), (this.periodoActual - 1), (this.periodoActual - 2)];

    this._apiService.procesarPeriodo(rut, this.periodos, userInfo.email, rut).subscribe(
      (resp: any) => {
        if (resp && Array.isArray(resp) && resp.length > 0) {
          // this.processResponses(resp, this.periodos); // Valida estados por mes por llamadas por periodo - valida los completed si hay se agregan a los resultados y se quitan de la lista a consultar
        } else {
          this.periodos = [];
          this.anyCompleted = false;
          this.errores.push({
            periodo: "-",
            mes: "-",
            msg: `Ha ocurrido un error al acceder a la información del reporte generado`
          });
        }

        if(this.periodos.length > 0) {
          this.llamadaAsincrona( this.periodos, rut, userInfo);
        } else {
          this.finFlujo(rut);
        }
      },
      ({ error }) => {
        this.toastr.error('', error.message || 'Ocurrió un error al realizar la consulta de creacion de reporte');  
        this.showReload = true;
      });
  }

  llamadaAsincrona(periodos: number[], rut: string, userInfo: IUserInfoCognito, delay: number = 0, llamadas: number = 15): void { // 0 seg, 20 llamadas
    if(llamadas > 0 && periodos.length > 0) {
      setTimeout(() => {
        this._apiService.obtenerTx(rut, periodos, userInfo.email, rut).subscribe(
          (resp: any) => {
            if (resp && Array.isArray(resp) && resp.length > 0) {
              this.processResponses(resp, periodos); // Valida estados por mes por llamadas por periodo - valida los completed si hay se agregan a los resultados y se quitan de la lista a consultar
            } else {
              periodos = [];
              this.anyCompleted = false;
              this.errores.push({
                periodo: "-",
                mes: "-",
                msg: `Ha ocurrido un error al acceder a la información del reporte generado`
              });
            }

            if(periodos.length > 0) {
              this.llamadaAsincrona( periodos, rut, userInfo, 8000, llamadas - 1); // 8 seg
            } else {
              this.finFlujo(rut);
            }
          },
          ({ error }) => {
            this.toastr.error('', error.message || 'Ocurrió un error al realizar al consultar los estados del reporte');  
            this.showReload = true;
          });
      }, delay);
    } else {
      this.finFlujo(rut);
    }
  }

  finFlujo(rut: string): void {    
    if(this.errores.length > 0) { // valida si hay errores y si estan repetidos para mostrarlos
      const mensajesMostrados: Set<string> = new Set();
  
      this.errores.forEach(e => {
        const mensaje: string = e?.msg || 'Ha ocurrido con uno de los reportes generados';
        if (!mensajesMostrados.has(mensaje)) {
          this.toastr.error('', mensaje);      
          mensajesMostrados.add(mensaje);
        }
      });
    }

    if(this.anyCompleted === true && this.errores.length < 1) {
      this.validatingCredentials = false;
    } else {
      this.anyCompleted = false;
      if(this.errores.length < 1) {
        this.toastr.error('', 'No se ha logrado obtener ningun reporte completado');   
      }
      this.validatingCredentials = false;
    }
  }

  // TODO!: enviar a un servicio dedicado
  processResponses(respuestaConsulta: any, periodos: number[]): void { // valida los estados de los reportes, si son correctos se agregan a la lista, sino se quitan de las ejecuciones, esto es para un periodo
    const array: any[] = respuestaConsulta;
    const periodosOriginal: number[] = [...periodos];

    for(const periodo of periodosOriginal) {
      const elementosFiltrados: any[] = array.filter(e => e?.LibroCompraVentaReporte?.Reporte?.periodo == periodo);
      if(elementosFiltrados.length > 0 && elementosFiltrados.every(e => e?.LibroCompraVentaReporte?.DatosBasicosSolicitud?.EstadoTransaccion !== 'IN-PROGRESS')) {
        this.removeElementByPeriodo(periodos, periodo);
      }
    }

    for(const elemento of array) {
      if(elemento.LibroCompraVentaReporte?.DatosBasicosSolicitud?.EstadoTransaccion === 'ERROR') {
        this.errores.push({
          periodo: elemento?.LibroCompraVentaReporte?.Reporte?.periodo,
          mes: elemento.LibroCompraVentaReporte?.Reporte?.mes || "-",
          msg: elemento.LibroCompraVentaReporte?.Reporte?.error || `Ha ocurrido un error al consultar el reporte con periodo ${elemento?.LibroCompraVentaReporte?.Reporte?.periodo} y con mes ${elemento.LibroCompraVentaReporte?.Reporte?.mes}`
        });
      }
    }

    if(array.some(e => e?.LibroCompraVentaReporte?.DatosBasicosSolicitud?.EstadoTransaccion === 'COMPLETED')) {
      this.anyCompleted = true;
    }
  }

  removeElementByPeriodo(periodos: number[], periodo: any): void { // remueve un objeto
    const index = periodos.findIndex(e => e == periodo);
    if (index >= 0) {
      periodos.splice(index, 1);
    }
  }

  reload() {
    location.reload();
  }
}
